import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] max-h-[900px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20abstract%20composition%20with%20flowing%20warm%20coral%20and%20deep%20crimson%20gradients%2C%20elegant%20geometric%20shapes%20in%20soft%20golden%20light%2C%20dark%20atmospheric%20background%20with%20subtle%20film%20grain%20texture%2C%20luxurious%20theater%20curtain%20like%20folds%2C%20sophisticated%20entertainment%20brand%20aesthetic%2C%20high-end%20cinematic%20mood&width=1800&height=1000&seq=hero-bg-main&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65" />

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse" />
            <span className="text-xs md:text-sm font-medium text-background-50/90">红桃视频官方网站 · 正版高清影视平台</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4">
            您的专属<span className="text-primary-400">高清影视</span>乐园
          </h1>

          <p className="text-sm md:text-base text-background-50/70 max-w-xl mx-auto mb-8 leading-relaxed">
            红桃视频官网是您访问红桃视频的唯一官方正版入口，提供高清视频播放、最新影视资源、
            会员专属内容及安全稳定的观看体验。立即访问，享受极致流畅的视频娱乐服务。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/tv-series"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
            >
              立即观看
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/10 backdrop-blur-sm text-background-50 font-medium rounded-full text-sm hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-50/20"
            >
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-6 md:gap-10 mt-12">
            {[
              { value: '5000万+', label: '累计用户' },
              { value: '10万+', label: '影视资源' },
              { value: '4K HDR', label: '超清画质' },
              { value: '7×24', label: '客服支持' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-lg md:text-2xl font-heading font-bold text-background-50">{stat.value}</div>
                <div className="text-xs text-background-50/50 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/50 text-2xl" />
      </div>
    </section>
  );
}